import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../../../consts/api";
import { http } from "../../../../services/HttpService";

export const useDeleteTimeTrackingConfig = (id, options = {}) => {
  const res = useMutation(
    (dto) =>
      http.delete(
        HTTP_ENDPOINTS.timeclockSettings.deleteTimeTrackingConfig(id),
        dto,
      ),
    {
      ...options,
    },
  );
  return res;
};
